import {ProcessActions} from '../../constants/constants';
import i18n from 'i18next';

export const MAX_USERS_TO_CLAIM_PROCESS = 2;

const processActionButtonLabel = {
  CLAIM: i18n.t('processes:processAssignee.runningProcessLabel.claim'),
  RECLAIM: i18n.t('processes:processAssignee.runningProcessLabel.reclaim'),
  DISCARD: i18n.t('processes:processAssignee.runningProcessLabel.discard'),
  TAKE_FROM: i18n.t('processes:processAssignee.reclaimOptionElementName'),
  PROCESS_ASSIGNEE: i18n.t('processes:processAssignee.processAssigneeOptionElementName')
};

export const processActions = {
  CLAIM: {
    name: processActionButtonLabel.CLAIM,
    optionElementName: processActionButtonLabel.TAKE_FROM,
    onClick: (callback, id) => {
      callback(
          id, ProcessActions.CLAIM, processActionButtonLabel.CLAIM
      );
    },
    optionElementOnClick: (callback, id, assigneeId?: number) => {
      callback(
          id, ProcessActions.RECLAIM,
          processActionButtonLabel.RECLAIM, assigneeId
      );
    },
    optionElementDisabled: false
  },
  RECLAIM: {
    name: processActionButtonLabel.RECLAIM,
    optionElementName: processActionButtonLabel.TAKE_FROM,
    onClick: (callback, id, assigneeId?: number) => {
      callback(
          id, ProcessActions.RECLAIM,
          processActionButtonLabel.RECLAIM, assigneeId
      );
    },
    optionElementOnClick: (callback, id, assigneeId?: number) => {
      callback(
          id, ProcessActions.RECLAIM,
          processActionButtonLabel.RECLAIM, assigneeId
      );
    },
    optionElementDisabled: false
  },
  DISCARD: {
    name: processActionButtonLabel.DISCARD,
    optionElementName: processActionButtonLabel.PROCESS_ASSIGNEE,
    onClick: (callback, id) => {
      callback(
          id, ProcessActions.DISCARD, processActionButtonLabel.DISCARD
      );
    },
    optionElementOnClick: (callback, id, assigneeId?: number) => {
      callback(
          id, ProcessActions.RECLAIM,
          processActionButtonLabel.RECLAIM, assigneeId
      );
    },
    optionElementDisabled: true
  }
};
